"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTestEnvironment = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("@icr-ui/theme");
const general_1 = require("../../general");
exports.StyledTestEnvironment = (0, styled_components_1.default)(general_1.Flexbox) `
  padding-block: 4px;
  background-color: ${theme_1.system.error};
  min-height: 24px;

  p {
    color: #fff;
    text-align: center;
  }
`;
//# sourceMappingURL=styles.js.map